module.exports = __webpack_public_path__ + "img/laugh.a6b0574b.svg";